import React from 'react';

import {Button, Col, DatePicker, Form, Input, Radio, Row, Select, Space, Switch, Typography} from 'antd';
import {UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';
import {ContestStatus, ContestType} from '../../hooks/apis/useContest';

const {Text, Title, Paragraph} = Typography;

export interface IContestEditForm {
  id?: number;
  name: string;
  type: ContestType;
  status: ContestStatus;
  isHide: boolean;
}

const ContestEditForm = (props: {form?: IContestEditForm; isLoading: boolean; onFinish: (value: IContestEditForm) => any}) => {
  const [form] = Form.useForm();

  const defaultForm: IContestEditForm = {
    isHide: false,
    name: '',
    status: ContestStatus.尚未开始,
    type: ContestType.知识竞赛类,
  };

  React.useEffect(() => {
    form.setFieldsValue(props.form || defaultForm);
  }, [props.form]);

  return (
    <Form
      labelCol={{span: 6}}
      wrapperCol={{span: 14}}
      layout={'horizontal'}
      form={form}
      onFinish={value => {
        value.id = props.form?.id;
        props.onFinish(value as IContestEditForm);
      }}>
      <Form.Item label={'活动名称'} name={'name'} rules={[{required: true}]}>
        <Input size={'large'} placeholder="请输入活动名称" />
      </Form.Item>
      <Form.Item label={'状态'} name={'status'} rules={[{required: true}]}>
        <Radio.Group>
          <Radio value={ContestStatus.尚未开始}>尚未开始</Radio>
          <Radio value={ContestStatus.进行中}>进行中</Radio>
          <Radio value={ContestStatus.已结束}>已结束</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={'类型'} name={'type'} rules={[{required: true}]}>
        <Radio.Group>
          <Radio value={ContestType.知识竞赛类}>知识竞赛类</Radio>
          <Radio value={ContestType.作品征集类}>作品征集类</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={'是否隐藏'} name={'isHide'} valuePropName={'checked'} rules={[{required: true}]}>
        <Switch />
      </Form.Item>
      <Row>
        <Col span={6} />
        <Col>
          <Space>
            <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit" className="login-form-button">
              保存
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default ContestEditForm;
